









import { defineComponent } from "@vue/composition-api";
import { Transaction } from "@scrile/api-provider/dist/api/TransactionProvider";
import useAuthUser from "@/hooks/useAuthUser";
import { $t } from "@/lib/i18nHelpers";
import { getDurationSymbols } from "@/lib/time";
import FormatMoney from "@/components/FormatMoney";
import TransactionView from "../TransactionView.vue";

export default defineComponent({
  name: "TransactionPaidCall",
  components: { TransactionView, FormatMoney },
  props: {
    transaction: { type: Object as () => Transaction, required: true },
  },
  setup() {
    const { authUserStrict } = useAuthUser();
    return {
      authUserStrict,
    };
  },
  computed: {
    isIncomingCall(): boolean {
      return this.transaction.details.call.receiverId === this.authUserStrict.id;
    },
    duration(): string {
      const duration = Math.floor(
        new Date(this.transaction.details.call.endTime).getTime() -
          new Date(this.transaction.details.call.startTime).getTime()
      );
      if (duration < 0) return "";
      const durationSymbols = getDurationSymbols(duration);
      const hoursString = durationSymbols.h === 0 ? "" : `${durationSymbols.h} ${$t("hr")} `;
      const minutesString = durationSymbols.m === 0 ? "" : `${durationSymbols.m} ${$t("min")} `;

      return `${hoursString}${minutesString}${durationSymbols.s} ${$t("sec")}`;
    },
    callType(): string {
      return $t("{0} call", [this.isIncomingCall ? $t("Incoming") : $t("Outgoing")]);
    },
    opponentName(): string {
      return (
        (this.isIncomingCall ? this.transaction.details.call.caller : this.transaction.details.call.receiver)
          ?.screenName ?? $t("User deleted")
      );
    },
  },
});
